
export class Permissions {
  /*_CONTRACT_NDA_ADD_:boolean = false

  _CONTRACT_NDA_EDIT_:boolean = false

  _CONTRACT_NDA_VIEW_:boolean = false

  _CONTRACT_NDA_DELETE_:boolean = false

  _CONTRACT_NDA_UPLOAD_:boolean = false

  _CONTRACT_NDA_DOWNLOAD_:boolean = false

  
  _CONTRACT_MSA_ADD_:boolean = false

  _CONTRACT_MSA_EDIT_:boolean = false

  _CONTRACT_MSA_VIEW_:boolean = false

  _CONTRACT_MSA_DELETE_:boolean = false

  _CONTRACT_MSA_UPLOAD_:boolean = false

  _CONTRACT_MSA_DOWNLOAD_:boolean = false


  _CONTRACT_SOW_ADD_:boolean = false

  _CONTRACT_SOW_EDIT_:boolean = false

  _CONTRACT_SOW_VIEW_:boolean = false

  _CONTRACT_SOW_DELETE_:boolean = false

  _CONTRACT_SOW_UPLOAD_:boolean = false

  _CONTRACT_SOW_DOWNLOAD_:boolean = false


  _CONTRACT_OFFER_LETTER_ADD_:boolean = false

  _CONTRACT_OFFER_LETTER_EDIT_:boolean = false

  _CONTRACT_OFFER_LETTER_VIEW_:boolean = false

  _CONTRACT_OFFER_LETTER_DELETE_:boolean = false

  _CONTRACT_OFFER_LETTER_UPLOAD_:boolean = false

  _CONTRACT_OFFER_LETTER_DOWNLOAD_:boolean = false*/

  _NOTIFICATION_ADD_:boolean = false

  _CONTRACT_TYPE_ADD_:boolean = false

  _CONTRACT_TYPE_EDIT_:boolean = false

  _CONTRACT_TYPE_VIEW_:boolean = false

  _CONTRACT_TYPE_DELETE_:boolean = false

  _CONTRACT_TYPE_UPLOAD_:boolean = false

  _CONTRACT_TYPE_DOWNLOAD_:boolean = false


  _REPORTS_ADD_:boolean = false

  _REPORTS_EDIT_:boolean = false

  _REPORTS_VIEW_:boolean = false

  _REPORTS_DELETE_:boolean = false

  _REPORTS_UPLOAD_:boolean = false

  _REPORTS_DOWNLOAD_:boolean = false


  _USER_MANAGEMENT_ADD_:boolean = false

  _USER_MANAGEMENT_EDIT_:boolean = false

  _USER_MANAGEMENT_VIEW_:boolean = false

  _USER_MANAGEMENT_DELETE_:boolean = false

  _USER_MANAGEMENT_UPLOAD_:boolean = false

  _USER_MANAGEMENT_DOWNLOAD_:boolean = false


  _TEMPLATES_ADD_:boolean = false

  _TEMPLATES_EDIT_:boolean = false

  _TEMPLATES_VIEW_:boolean = false

  _TEMPLATES_DELETE_:boolean = false

  _TEMPLATES_UPLOAD_:boolean = false

  _TEMPLATES_DOWNLOAD_:boolean = false

  _CLAUSES_ADD_:boolean = false

  _CLAUSES_EDIT_:boolean = false

  _CLAUSES_VIEW_:boolean = false

  _CLAUSES_DELETE_:boolean = false

  _CLAUSES_UPLOAD_:boolean = false

  _CLAUSES_DOWNLOAD_:boolean = false


  _NOTIFICATIONS_ADD_:boolean = false

  _NOTIFICATIONS_EDIT_:boolean = false

  _NOTIFICATIONS_VIEW_:boolean = false

  _NOTIFICATIONS_DELETE_:boolean = false

  _NOTIFICATIONS_UPLOAD_:boolean = false

  _NOTIFICATIONS_DOWNLOAD_:boolean = false
}
